import { tv } from 'tailwind-variants';

import { iconSizeVariants } from '../Icons.styles';

export const sortIconStyles = tv({
  base: 'inline-flex items-center justify-center transition-transform duration-300',
  variants: {
    size: iconSizeVariants
  }
});
